import { removeToken } from '@/utils/auth'
import {fechListLessonTemplate} from "../api/superAdmin";
import commonUtils from "./commonUtils";
import {selectAllCard, selectCards, selectWorkerPosition,findStoreById} from "../api/storeFront";
import {qlLessonTemplate, selectValidLessonTemplate} from "../api/StoreLesson";
import {selectList} from "../api/scheduleTimeTemplate";
import {selectAllWorkerInfo} from "../api/StoreWorkers";
import {qlStoreLevelLesson} from "../api/StoreLevelLesson";
import {qlSwCircle} from "../api/StoreSetting";
import {selectAll} from "../api/Classroom";
import {queryGoods} from "../api/Goods";

export default class GlobalData {

  /**
   * 是否是登录
   * @type {boolean}
   */

  static _isFinish = "finish";
  static _isLogin = "isLogin";
  static _AdminStore = "_AdminStore";
  static _accountInfoKey = 'accountInfo'
  static _lessonTemplate = 'lessonTemplate'       //超级管理员所有的课程模板
  static _storeLessonTemplate = "storeLessonTemplate "    //门店所有的课程模板
  static _storeLessonCard = "storeLessonCard "    //店铺可以使用的课程模板
  static _storePositions = "storePositions"    //店铺职位列表
  static _storeScheduingTempLate = "storeScheduingTempLate"    //店铺所有排班模板
  static _storeWorkersInfo = "storeWorkersInfo"    //店铺所有员工的姓名
  static _storeLevelLesson = "storeLevelLesson"    //店铺的等级课程

  static _storeSwimCircle = "storeSwimCircle"    //店铺的泳圈
  static _classroom = "_classroom"    //店铺的等级课程
  static _storeGoods = "_storeGoods" //店铺物品

  static _anotherName = "_anotherName" //亲子别名
  /**
   * localStorage存储本地数据
   * @param key 存储关键字段
   * @param data 存储数据
   */
  static saveItem(key,data){
    if(key&&data){
      const newData = JSON.stringify(data);
      localStorage.setItem(key,newData);
    }else {
      throw new Error('关键字或者data不能为空');
    }
  }

  /**
   * localStorage存储本地数据
   * @param key 存储关键字段
   */
  static getItem(key){
    if(key){
      return localStorage.getItem(key);
    }else {
      throw new Error('关键字不能为空');
    }
  }
  /**
   * localStorage通过关键字移除数据
   * @param key 存储关键字段
   */
  static removeItem(key){
    if(key){
      localStorage.removeItem(key);
    }else {
      throw new Error('关键字不能为空');
    }
  }
  /**
   * localStorage 清楚localStorage本地所有缓存
   */
  static clear(){
    localStorage.clear();
  }

  /**
   * ---------------------------------------------------------------------------------------------------------------------------------
   * ---------------------------------------------------------------------------------------------------------------------------------
   */


  /**
   *
   * @param account
   */
  static set_AdminStore(data){
    this.saveItem(this._AdminStore, data);
  }

  /**
   *
   */
  static getAdminStore(){
    var data = this.getItem(this._AdminStore);
    if(data){
      return JSON.parse(data);
    }
    return null;
  }


  /**
   *
   * @param account
   */
  static setLessonTemplate(lt){
    this.saveItem(this._lessonTemplate, lt);
  }

  /**
   *
   */
  static getLessonTemplate( callback){
    var lt = this.getItem(this._lessonTemplate);
    if(lt){
      if (callback){
        callback(JSON.parse(lt));
      }
    }else {
      fechListLessonTemplate().then(response =>
      {
        let date = response.data;
        if (commonUtils.isObjectNull(date)){
          return;
        }
        this.setLessonTemplate(date);
        callback(JSON.parse(date));
      })
    }
    return null;
  }


  /**
   *
   * @param account
   */
  static setStoreLessonTemplate(lt){
    this.saveItem(this._storeLessonTemplate, lt);
  }
  /**
   *
   */
  static getStoreLessonTemplate( callback){
    var lt = this.getItem(this._storeLessonTemplate);
    if(false){
      if (callback){
        callback(JSON.parse(lt));
      }
    }else {
      let anotherName = "亲子游";
      let  param1 = {
        id:this.getAdminStore().storeFrontId
      }
      findStoreById(param1).then(response =>
      {
        let data1 = response.data;
        if (!commonUtils.isObjectNull(data1)){
          anotherName = data1.anotherName;
          //console.info(anotherName);

          let  param = {
            storeFrontId:this.getAdminStore().storeFrontId
          }
          selectValidLessonTemplate(param).then(response =>
          {
            let data = response.data;
            if (commonUtils.isObjectNull(data)) {
              return;
            }

            // for(let i = 0 ; i< data.length;i++){
            //   console.info(data);
            //   if(data[i].id == 1){
            //     data[i].type = anotherName;
            //   }
            // }

            this.setStoreLessonTemplate(data);
            if (callback){
              callback(data)
            }
          })

        }
      })


    }
    return null;
  }

  static getStoreLessonTemplateById(id){
    var lt = this.getItem(this._storeLessonTemplate);
    if (lt){
      lt = JSON.parse(lt)
      for (let i = 0;i<lt.length;++i ){
        if (lt[i].id == id){
          return lt[i];
        }
      }
    }
    return null;
  }

  static setStoreLessonCard(lt){
    this.saveItem(this._storeLessonCard, lt);
  }
  //获取店铺所有开的卡
  static getStoreLessonCard(callback){

    var lt = this.getItem(this._storeLessonCard);
    if(false){
      if (callback){
        callback(JSON.parse(lt));
      }
    }else{
      let  param = {
        storeFrontId:this.getAdminStore().storeFrontId,
        statu:0,
      }
      selectCards(param).then(response =>
      {
        let data = response.data;
        if (commonUtils.isObjectNull(data)){
          return;
        }
        this.setStoreLessonCard(data);
        if (callback){
          callback(data)
        }
      })
    }
  }




  static setStorePositions(lt){
    this.saveItem(this._storePositions, lt);
  }
  //获取店铺所有职位
  static getStorePosition(callback){
    var lt = this.getItem(this._storePositions);
    if(false){
      if (callback){
        callback(JSON.parse(lt));
      }
    }else{
      let  param = {
        storeFrontId:this.getAdminStore().storeFrontId
      }
      selectWorkerPosition(param).then(response =>
      {
        let data = response.data;
        if (commonUtils.isObjectNull(data)){
          return;
        }
        let list = data;
        this.setStorePositions(list);
        if (callback){
          callback(list)
        }
      })
    }
  }


  static setStoreScheduingTempLate(lt){
    this.saveItem(this._storeScheduingTempLate, lt);
  }
  //获取店铺所有排班模板
  static getStoreScheduingTempLate(callback){
    var lt = this.getItem(this._storeScheduingTempLate);
    if(false){
      if (callback){
        callback(JSON.parse(lt));
      }
    }else{
      let  param = {
        storeFrontId:this.getAdminStore().storeFrontId
      }
      selectList(param).then(response =>
      {
        let data = response.data;
        if (commonUtils.isObjectNull(data)){
          return;
        }
        this.setStoreScheduingTempLate(data);
        if (callback){
          callback(data)
        }
      })
    }
  }





  static setStoreWorkersInfo(lt){
    this.saveItem(this._storeWorkersInfo, lt);
  }
  static setClassroom(lt){
    this.saveItem(this._classroom, lt);
  }
  static setStoreGoods(lt){
    this.saveItem(this._storeGoods, lt);
  }
  static setAnotherName(lt){
    this.saveItem(this._anotherName, lt);
  }
  //获取店铺所有员工
  static getStoreWorkersInfo(callback){
    var lt = this.getItem(this._storeWorkersInfo);
    if(false){
      if (callback){
        callback(JSON.parse(lt));
      }
    }else{
      let  param = {
        storeFrontId:this.getAdminStore().storeFrontId
      }
      selectAllWorkerInfo(param).then(response =>
      {
        let data = response.data;
        if (commonUtils.isObjectNull(data)){
          return;
        }
        this.setStoreWorkersInfo(data);
        if (callback){
          callback(data)
        }
      })
    }
  }

  //获取店铺所有教室
  static getClassroom(callback){
    var lt = this.getItem(this._classroom);
    if(false){
      if (callback){
        callback(JSON.parse(lt));
      }
    }else{
      let  param = {
        shopFrontId:this.getAdminStore().storeFrontId
      }
      selectAll(param).then(response =>
      {
        let data = response.data;
        if (commonUtils.isObjectNull(data)){
          return;
        }
        this.setClassroom(data);
        if (callback){
          callback(data)
        }
      })
    }
  }

  //获取所有商品
  static getStoreGoods(callback){
    var lt = this.getItem(this._storeGoods);
    if(false){
      if (callback){
        callback(JSON.parse(lt));
      }
    }else{
      let  param = {
        shopFrontId:this.getAdminStore().storeFrontId
      }
      queryGoods(param).then(response =>
      {
        let data = response.data;
        if (commonUtils.isObjectNull(data)){
          return;
        }
        this.setStoreGoods(data);
        if (callback){
          callback(data)
        }
      })
    }
  }


  //获取亲子游别名
  static getAnotherName(callback){
    var lt = this.getItem(this._anotherName);
    if(false){
      if (callback){
        callback(JSON.parse(lt));
      }
    }else{
      let  param = {
        id:this.getAdminStore().storeFrontId
      }
      findStoreById(param).then(response =>
      {
        let data = response.data;
        if (commonUtils.isObjectNull(data)){
          console.info("null")
          return;
        }
        this.setAnotherName(data);
        if (callback){
          callback(data)
        }
      })
    }
  }

  static setStoreLevelLesson(lt){
    this.saveItem(this._storeLevelLesson, lt);
  }
  //获取店铺等级课程
  static getStoreLevelLesson(callback){
    var lt = this.getItem(this._storeLevelLesson);
    if(false){
      if (callback){
        callback(JSON.parse(lt));
      }
    }else{
      let  param = {
        storeFrontId:this.getAdminStore().storeFrontId
      }
      qlStoreLevelLesson(param).then(response =>
      {
        let data = response.data;
        if (commonUtils.isObjectNull(data)){
          return;
        }
        console.info(data);
        this.setStoreLevelLesson(data);
        if (callback){
          callback(data)
        }
      })
    }
  }


  static setStoreSwimCircle(lt){
    this.saveItem(this._storeSwimCircle, lt);
  }
  //获取店铺泳圈
  static getStoreSwimCircle(callback){
    var lt = this.getItem(this._storeSwimCircle);
    if(false){
      if (callback){
        callback(JSON.parse(lt));
      }
    }else{
      let  param = {
        storeFrontId:this.getAdminStore().storeFrontId
      }
      qlSwCircle(param).then(response =>
      {
        let data = response.data;
        if (commonUtils.isObjectNull(data)){
          return;
        }
        this.setStoreSwimCircle(data);
        if (callback){
          callback(data)
        }
      })
    }
  }

  /**
   *
   * @param account
   */
  static setAccountInfo(accountInfo){
    this.saveItem(this._accountInfoKey, accountInfo);
  }

  /**
   *
   */
  static getAccountInfo(){
    let accountInfo = this.getItem(this._accountInfoKey);
    if(accountInfo){
      return JSON.parse(accountInfo);
    }
    return null;
  }

  /**
   *
   * @param login
   */
  static setLogin(login){
    this.saveItem(this._isLogin, login);

  }

  /**
   *
   * @param login
   */
  static getLogin(login){
    let isLogin = this.getItem(this._isLogin);
    return isLogin
  }

  /**
   *
   * @param login
   */
  static setFinish(finish){
    console.log('setFinish',finish)
    this.saveItem(this._isFinish, finish);

  }

  /**
   *
   * @param login
   */
  static getFinish(login){
    let finish = this.getItem(this._isFinish);
    return finish
  }




  /**
   *
   */
  static clearAll(){

    console.log("clearAll");


    //删除token
    removeToken();

    this.removeItem(this._isFinish);
    this.removeItem(this._isLogin);
    this.removeItem(this._AdminStore);
    this.removeItem(this._accountInfoKey);
    this.removeItem(this._lessonTemplate);
    this.removeItem(this._storeLessonTemplate);
    this.removeItem(this._storeLessonCard);
    this.removeItem(this._storePositions);
    this.removeItem(this._storeScheduingTempLate);
    this.removeItem(this._storeWorkersInfo);
    this.removeItem(this._storeLevelLesson);
    this.removeItem(this._storeSwimCircle);

  }


}



// WEBPACK FOOTER //
// ./src/utils/globaldata.js